/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { InpectionPhase } from "../inspection.d";
import DisabledAnswersColumn from "./DisabledAnswersColumn";
import AnswerColumn from "./AnswersColumn";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import type { IAnswer } from "@/types/types";
import { closeNaPhase, getAnswers } from "@/lib/services/answers";
import { usePhase } from "@/store/usePhase";
import { getLabelPhase } from "../utils/getLabelPhase";
import { useParams } from "react-router-dom";
import { useUserStore } from "@/store/useUser";
import ProblemMessage from "@/components/problem-message/ProblemMessage";
import useInspectionId from "@/store/useInspectionId";
import { getInspectionId } from "@/lib/services/inspections";
import CloseNaPhaseModal from "./CloseNaPhaseModal";

const AnswerGroup = ({
  phase,
  questions,
}: {
  phase: InpectionPhase;
  questions: any[];
}) => {
  const { isSupervisor } = useUserStore();
  const phaseLabel = useMemo(() => {
    return getLabelPhase(phase.phaseId);
  }, []);
  const { currentPhase, setCompleted, setCurrentPhase, setAllNa } = usePhase();
  const queryKey = useMemo(() => `answers-${phase.phaseId}`, [phase.phaseId]);
  const { inspectionId } = useParams() as { inspectionId: string };
  const [errorNa, setErrorNa] = useState(false);
  const [closeNaModal, setCloseNaModal] = useState(false);
  const translate = useTranslate();
  const {
    data: answers,
    isPending,
    error,
  } = useQuery({
    queryKey: [queryKey, inspectionId],
    queryFn: () =>
      getAnswers({
        inspectionId: Number(inspectionId),
        phaseId: phase.phaseId,
      }),
  });

  const { updateInspectionData } = useInspectionId();

  useEffect(() => {
    if (currentPhase === phase.phaseId && inspectionId && answers) {
      setCompleted(answers.length);
      const allNa = answers.every(
        (answer: { status: string }) =>
          answer.status && answer.status === "N/A",
      );
      setAllNa(allNa);
    }
  }, [answers, currentPhase, phase]);

  if (isPending) {
    return <div>Cargando</div>;
  }
  if (error) {
    <div>error</div>;
  }

  const closeWhitAllNa = async (esnOut?: string) => {
    try {
      await closeNaPhase(inspectionId, phase.phaseId, esnOut);
      const newInspectionData = await getInspectionId({
        id: Number(inspectionId),
      });
      updateInspectionData(newInspectionData);
      setCurrentPhase(newInspectionData.phase);
      setCloseNaModal(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      setCloseNaModal(false);
      setErrorNa(true);
    }
  };

  if (!isSupervisor && phase.phaseId === currentPhase) {
    return (
      <>
        <AnswerColumn
          questions={questions}
          columnName={translate(phaseLabel)}
          answers={answers as IAnswer[]}
          closeWhitAllNa={closeWhitAllNa}
          askClosePhaseWithNa={() => setCloseNaModal(true)}
        />
        {errorNa ? (
          <ProblemMessage
            error={translate("noPosibleSaveChange")}
            closeMessage={() => setErrorNa(false)}
          />
        ) : null}
        {closeNaModal ? (
          <CloseNaPhaseModal
            closeWhitAllNa={closeWhitAllNa}
            cancel={() => setCloseNaModal(false)}
          />
        ) : null}
      </>
    );
  }

  return (
    <DisabledAnswersColumn
      answers={answers}
      questionsList={questions}
      columnName={translate(phaseLabel)}
      columnPhase={phase.phaseId}
      questions={questions.length}
    />
  );
};

export default AnswerGroup;
